// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1rCZQ","header":"MessagesList_header__2gzYj","chat":"MessagesList_chat__1UaDW"};